import * as Cookie from 'js-cookie';

export function getCSRFToken(): string {
    return Cookie.get('_direct_csrf_token') || '';
}
